import { api } from './client';

export interface CurrentUser {
  id: string;
  telegram_id: number;
  first_name: string;
  last_name?: string | null;
  username?: string;
  language_code?: string | null;
  display_name: string;
}

export function getCurrentUser(): Promise<CurrentUser> {
  return api.get<CurrentUser>('/api/v1/me');
}
